import classNames from 'classnames';
import styles from './M1ArticleModule.module.scss';
import { Heading } from 'ui/components/1-atoms';
import { EditorialRichText } from 'ui/components';
import { SurfaceSection } from 'ui/components/4-habitats/SurfaceSection/SurfaceSection';
export interface M1ArticleModuleProps {
	title?: string;
	subtitle?: string;
	text?: string;
	anchor?: string;
	backgroundColorKey?: string | null;
	isWide?: boolean;
}

export const M1ArticleModule: React.FC<M1ArticleModuleProps> = ({ title, subtitle, text, anchor, backgroundColorKey, isWide }) => {
	return (
		<SurfaceSection
			className={classNames(styles.M1ArticleModule, { [styles.M1ArticleModule___wide]: isWide })}
			surfaceKey={backgroundColorKey}
			withContainer
			containerWidth={isWide ? 'StandardWeb' : 'SlimWeb'}
			id={anchor}
		>
			<article className={classNames(styles.M1ArticleModule_article)}>
				{title && (
					<Heading headingLevel="h1" className={classNames(styles.M1ArticleModule_heading)}>
						{title}
					</Heading>
				)}
				{subtitle && <p className={classNames(styles.M1ArticleModule_subtitle)}>{subtitle}</p>}
				{text && <EditorialRichText variant="website" content={text} className={classNames(styles.M1ArticleModule_richTextContent)} />}
			</article>
		</SurfaceSection>
	);
};

export default M1ArticleModule;
